import graphql__13d234c7811820c3d843 from "./__generated__/SettlementHeader_settlement.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useFragment} from "react-relay/hooks";
import StatusBadge from "./presentational/StatusBadge";
import {useIntl} from "react-intl";

type SettlementHeaderProps = {
    settlement: any
    language: string | undefined
}

const SettlementHeader: React.FC<SettlementHeaderProps> = (props) => {
    const intl = useIntl();

    const getStatusLabel = (status: string): string => {
        switch (status) {
            case 'OPEN':
                return intl.formatMessage({id: 'header.settlement.status.open'});
            case 'INVOICED':
                return intl.formatMessage({id: 'header.settlement.status.invoiced'});
            case 'FINALIZED':
                return intl.formatMessage({id: 'header.settlement.status.finalized'});
            case 'CLOSED':
                return intl.formatMessage({id: 'header.settlement.status.closed'});
        }
        return intl.formatMessage({id: 'header.settlement.status.unknown'})
    }
    const settlement = useFragment(
        graphql__13d234c7811820c3d843,
        props.settlement
    )

    const translate = (translatedString: { en: string, de: string } | null) => {
        if (!translatedString) {
            return null
        }
        return props.language === 'de' ? translatedString.de : translatedString.en;
    }

    return (
        <div className="mt-6 mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
            <div className="flex items-center space-x-5">
                <div>
                    <h2 className="text-xl font-medium text-gray-700">{settlement.customerAccount.customerName}</h2>
                    <h1 className="text-2xl font-bold text-gray-900">
                        {translate(settlement.title)}
                        <StatusBadge
                            value={settlement.status}
                            states={{gray: ['OPEN'], green: ['INVOICED', 'FIXED_FEE']}}
                            label={getStatusLabel(settlement.status)}
                            size="base"
                            className="mx-2"
                        />
                    </h1>
                    <p className="text-sm font-medium text-gray-500">{settlement.id}</p>
                </div>
            </div>
        </div>
    )
}

export default SettlementHeader;
